// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activeButton {
  background-color:lightgreen;
}
@media(max-width: 900px){
  .hideMobile {
    display: none;
  }
}

@media(min-width: 900px){

    /* filter date */
  .hideDesktop {
    display: none;
  }

}
`, "",{"version":3,"sources":["webpack://./src/app/sale/sale-home/sale-home.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;IAEI,gBAAgB;EAClB;IACE,aAAa;EACf;;AAEF","sourcesContent":[".activeButton {\n  background-color:lightgreen;\n}\n@media(max-width: 900px){\n  .hideMobile {\n    display: none;\n  }\n}\n\n@media(min-width: 900px){\n\n    /* filter date */\n  .hideDesktop {\n    display: none;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
